var blogMedia = {
    init: function() {
        this.initSlider();
        this.initVideos();
        this.initLightbox();
    },

    initSlider: function() {
        var $sliders = $( '[data-blog-slider]' );

        if ( $sliders.length < 1 || typeof $.fn.slick === 'undefined' ) {
            return;
        }

        $sliders.each( function() {
            var $slider = $( this );

            $slider.slick( {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '40px',
                infinite: true,
                arrows: true,
                dots: false,
                mobileFirst: false,
                prevArrow: '<button type="button" class="post-detail__slider__arrow post-detail__slider__arrow--prev"><i class="icon-arrow-reverse"></i></button>',
                nextArrow: '<button type="button" class="post-detail__slider__arrow post-detail__slider__arrow--next"><i class="icon-arrow"></i></button>',
                responsive: [
                    { breakpoint: 992, settings: { slidesToShow: 1, centerPadding: '60px' } },
                    { breakpoint: 600, settings: { slidesToShow: 1, centerPadding: '24px' } }
                ]
            } );

            $( window ).on( 'load', function() {
                $slider.slick( 'setPosition' );
            } );
        } );
    },

    initVideos: function() {
        $( '[data-blog-video]' ).each( function() {
            var $wrap = $( this );

            $wrap.on( 'click', '[data-blog-video-poster]', function( e ) {
                e.preventDefault();

                var id = $wrap.attr( 'data-yt-id' );

                if ( ! id ) {
                    return;
                }

                var src    = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
                var iframe = '<iframe class="post-detail__video__iframe" src="' + src + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen frameborder="0"></iframe>';

                $wrap.addClass( 'is-playing' ).html( iframe );
            } );
        } );
    },

    initLightbox: function() {
        var $items = $( '[data-lightbox]' );

        if ( $items.length < 1 ) {
            return;
        }

        var $overlay = $(
            '<div class="lightbox">' +
                '<button class="lightbox__close" type="button" aria-label="Zavřít">&times;</button>' +
                '<button class="lightbox__nav lightbox__nav--prev" type="button" aria-label="Předchozí"><i class="icon-arrow-reverse"></i></button>' +
                '<figure class="lightbox__figure"><img class="lightbox__image" src="" alt=""><figcaption class="lightbox__caption"></figcaption></figure>' +
                '<button class="lightbox__nav lightbox__nav--next" type="button" aria-label="Další"><i class="icon-arrow"></i></button>' +
            '</div>'
        );

        $( document.body ).append( $overlay );

        var group = [];
        var index = 0;

        function show( i ) {
            if ( group.length < 1 ) {
                return;
            }

            index = ( i + group.length ) % group.length;

            var item = group[ index ];

            $overlay.find( '.lightbox__image' ).attr( 'src', item.src );

            var $caption = $overlay.find( '.lightbox__caption' );
            $caption.text( item.caption );
            $caption.css( 'display', item.caption ? 'block' : 'none' );

            $overlay.find( '.lightbox__nav' ).css( 'display', group.length > 1 ? 'block' : 'none' );
        }

        function open( $el ) {
            var name      = $el.attr( 'data-lightbox-group' );
            var $groupEls = $( '[data-lightbox-group="' + name + '"]' );

            group = $groupEls.map( function() {
                return {
                    src: $( this ).attr( 'data-lightbox-src' ),
                    caption: $( this ).attr( 'data-lightbox-caption' ) || ''
                };
            } ).get();

            show( $groupEls.index( $el ) );

            $( document.body ).addClass( 'lightbox-open' );
        }

        function close() {
            $( document.body ).removeClass( 'lightbox-open' );
        }

        $items.on( 'click', function( e ) {
            e.preventDefault();
            open( $( this ) );
        } );

        $overlay.on( 'click', '.lightbox__close', close );
        $overlay.on( 'click', '.lightbox__nav--prev', function() { show( index - 1 ); } );
        $overlay.on( 'click', '.lightbox__nav--next', function() { show( index + 1 ); } );
        $overlay.on( 'click', function( e ) {
            if ( e.target === this ) {
                close();
            }
        } );

        $( document ).on( 'keydown', function( e ) {
            if ( ! $( document.body ).hasClass( 'lightbox-open' ) ) {
                return;
            }

            if ( 27 === e.keyCode ) { close(); }
            if ( 37 === e.keyCode ) { show( index - 1 ); }
            if ( 39 === e.keyCode ) { show( index + 1 ); }
        } );
    }
};

export {
    blogMedia
};
